import {ApiCollection} from "./api.collection";
import {ClientCode} from "../models/client-code.model";

export const ClientCodes = ApiCollection.extend({
    model: ClientCode,
    comparator: 'name',
    url: 'api/client_codes',
});
